import styles from "../HealthChat.module.css";

/* ─── SVG Icons ──────────────────────────────────────────────────────────── */
const BookIcon = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const DoctorIcon = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4.5 6.5a4 4 0 0 0 8 0V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2.5z" />
    <path d="M8.5 10.5v4a5 5 0 0 0 10 0v-1" />
    <circle cx="19" cy="12" r="1.5" fill="var(--primary-color)" />
  </svg>
);

const SymptomsIcon = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

const ResourcesIcon = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const ChatIcon = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="13" y2="14" />
  </svg>
);

/* ─── Card config ────────────────────────────────────────────────────────── */
const CARDS = [
  {
    id: "symptoms",
    label: "Have a Health Concenrs",
    Icon: SymptomsIcon,
  },
  {
    id: "consult",
    label: "Book An Appointment",
    Icon: DoctorIcon,
  },
  {
    id: "lifeStage",
    label: "Life Stage",
    Icon: ResourcesIcon,
  },
  {
    id: "resources",
    label: "Explore Women's Programs",
    Icon: BookIcon,
  },
  {
    id: "healthAssessment",
    label: "Take a Health Assessment",
    Icon: SymptomsIcon,
  },
  {
    id: "ask",
    label: "Ask a Question",
    Icon: ChatIcon,
  },
];

/* ─── Component ─────────────────────────────────────────────────────────── */
export default function ChatHomeScreen({ onSelect, patientName, onBack }) {
  const firstName = patientName ? patientName.split(" ")[0] : null;

  return (
    <div className={styles.chatHomeScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      {/* ── Greeting header ── */}
      <div className={styles.chatHomeHeader}>
        <img
          src="/images/chatbot.svg"
          alt="bot"
          className={styles.chatHomeBotImg}
          width={52}
          height={52}
        />
        <div>
          <div className={`${styles.chatHomeGreetTitle} ${styles.CBheading3}`}>
            {firstName ? `Hi ${firstName},` : "Hi,"} how can I assist you today?
          </div>
          <div className={`${styles.chatHomeGreetSub} ${styles.CBbodyText}`}>
            I'm here to help with all your women's health needs.
          </div>
        </div>
      </div>

      {/* ── Action cards ── */}
      <div className={styles.chatHomeGrid}>
        {CARDS.map(({ id, label, desc, Icon }) => (
          <div
            key={id}
            className={styles.chatHomeCard}
            onClick={() => onSelect(id)}
          >
            <div className={styles.chatHomeCardIcon}>
              <Icon size={38} />
            </div>
            <div className={`${styles.chatHomeCardLabel} ${styles.CBbodyText}`}>
              {label}
            </div>
            <div className={`${styles.chatHomeCardDesc} ${styles.CBbodyText}`}>
              {desc}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
